import { get, post, downloadPost } from 'services/api-client';

const adminService = {
  getRoles: () => get('/admin/roles'),
  getByUserId: (userId) => get(`/admin/getByUserId?userId=${userId}`),
  create: (email) => post(`/admin?email=${email}`),
  createProfile: (data) => post(`/admin/createProfile`, data),
  getTags: () => get('admin/getTags'),
  createClientAdmin: (data) => post('admin/createClientAdmin', data),
  getClientsForClientAdmin: () => get('admin/getClientsForClientAdmin'),
  downloadHealthQuotient: (data) => downloadPost('admin/downloadHealthQuotient', data, 'health-quotient-answers.csv'),
  downloadHistoricalReport: (data, client, date) => downloadPost('admin/downloadHistoricalReportData', data, `historical_data_${client}_${date}.csv`)
}

export default adminService;
